import { Typography as MuiTypography, TypographyProps } from "@mui/material";

type Props = TypographyProps;

export const Typography = ({ children, ...props }: Props) => {
  return <MuiTypography {...props}>{children}</MuiTypography>;
};

export function AnyComponentTypography<C extends React.ElementType>({ children, ...props }: TypographyProps<C, { component?: C }>) {
  return <Typography {...props}>{children}</Typography>;
}
